<template>
  <div v-if="safeItem" class="auction-info">
    <div
      class="auction-title"
      :class="safeItem.is_auction_end == 0 ? 'ing' : 'over'"
    >
      <van-icon name="underway" />
      <span>{{ safeItem.auction_button_text }}</span>
      <van-icon
        name="question-o"
        style="margin-left: 4px"
        color="#000"
        size="18"
        @click="show = true"
      />
      <div class="auction-time" v-if="safeItem.is_auction_end == 0">
        <van-count-down :time="time">
          <template #default="timeData">
            <span class="block" v-if="timeData.days > 0"
              >{{
                timeData.days < 10 ? '0' + timeData.days : timeData.days
              }}
              天&nbsp;</span
            >
            <span class="block">{{
              timeData.hours < 10 ? '0' + timeData.hours : timeData.hours
            }}</span>
            <span class="colon">:</span>
            <span class="block">{{
              timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes
            }}</span>
            <span class="colon">:</span>
            <span class="block">{{
              timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds
            }}</span>
          </template>
        </van-count-down>
      </div>
      <div class="auction-time" v-else>
        {{ safeItem.auction_end_time }}
      </div>
    </div>
    <div class="auction-pro">
      <van-row>
        <van-col :span="12"
          >起拍价格：￥
          <span class="money">{{ safeItem.starting_price }}</span></van-col
        >
        <van-col :span="12"
          >加价幅度：￥
          <span class="money">{{ safeItem.auction_price }}</span></van-col
        >
      </van-row>
      <van-row style="margin-top: 10px">
        <van-col :span="12">佣金：<span class="money1">有</span></van-col>
        <van-col :span="12"
          >买家保证金：￥
          <span class="money1">{{ safeItem.shop_bail }}</span> 万</van-col
        >
      </van-row>
    </div>
    <div
      class="auction-record"
      v-if="safeItem.auction_records && safeItem.auction_records.length > 0"
    >
      <van-cell-group>
        <van-cell
          v-for="(item, index) in safeItem.auction_records"
          :key="index"
        >
          <template #title>
            <div style="display: flex; gap: 8px">
              <van-image
                round
                width="40px"
                height="40px"
                src="https://b.yzcdn.cn/vant/icon-demo-1126.png"
              />
              <div style="flex: 1; height: 40px; line-height: 40px">
                {{ item.name }}
              </div>
            </div>
          </template>
          <template #default>
            <div style="position: relative">
              <p class="auction-state" :class="item.status_text">
                {{
                  item.status_text == 'success'
                    ? '成功'
                    : item.status_text == 'bidding'
                    ? '竞价'
                    : '出局'
                }}
              </p>
              <div class="auction-record-time">{{ item.bidding_time }}</div>
            </div>
          </template>
          <template #label>
            <span class="auction-money">￥ {{ item.price }}</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <van-popup
      v-model="show"
      round
      closeable
      :style="{ height: '80%', width: '80%' }"
    >
      <div style="padding: 40px 10px 10px; overflow: hidden">
        <div
          style="
            overflow-y: auto;
            width: 100%;
            height: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
          "
          v-html="rule"
        ></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'ProductAuctionLst',
  props: ['item', 'rules'],
  computed: {
    safeItem () {
      return this.item || null
    },
    safeRule () {
      return this.rules || ''
    }
  },
  watch: {
    item (val) {
      if (val && this.time == 0) {
        this.getMs()
      }
    }
  },
  data () {
    return {
      time: 0,
      show: false,
      rule: null
    }
  },
  mounted () {
    this.getRule()
  },
  methods: {
    getMs () {
      const targetTimeStr = this.safeItem.auction_end_time
      const targetDate = new Date(targetTimeStr.replace(/ /g, 'T'))
      const currentDate = new Date(this.safeItem.service_time * 1000)
      console.log(currentDate)
      this.time = targetDate.getTime() - currentDate.getTime()
      console.log(this.time)
    },
    async getRule () {
      await this.$http({
        method: 'post',
        url: 'auctionrule'
      }).then(res => {
        this.rule = res.data.value
        // this.rule = "<p>111111111111111111111111111111111111111111111111111111</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p><p>1</p>"
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.auction-info {
  margin: 10px 10px 10px;
  padding: 15px 10px 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  position: relative;
  .auction-title {
    position: absolute;
    width: calc(100% - 20px);
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    top: 0;
    left: 0;
    padding: 10px;

    span {
      margin-left: 10px;
      font-weight: 600;
    }
  }
  .over {
    background: #fee6e9;
    color: #f0364b;
  }
  .ing {
    color: #2ac07c;
    background: #cdeadd;
  }
  .auction-time {
    float: right;
  }
  .auction-pro {
    margin: 41px 0 10px;
    font-size: 14px;
  }
}

.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}
.block {
  display: inline-block;
  width: 22px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #ee0a24;
  border-radius: 8px;
}
.auction-money {
  font-size: 16px;
  font-weight: 600;
  color: #ee0a24;
}
.auction-state {
  width: 50px;
  padding: 5px 10px;
  border-radius: 8px;
  position: absolute;
  right: 0px;
  text-align: center;
}
.auction-record-time {
  position: absolute;
  right: 0px;
  top: 38px;
}
.failed {
  background: #fee6e9;
  color: #f0364b;
}
.success {
  color: #2ac07c;
  background: #cdeadd;
}
.bidding {
  color: #272828;
  background: #ced1cf;
}
.money {
  color: #f0364b;
  font-size: 20px;
}
.money1 {
  color: #2ac07c;
  font-size: 20px;
}
</style>
